import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * NOTE: Business unit names contains underscore in the token but we want to handle them with spaces because they have
 * to match with business units coming from the UPM.
 */

interface BusinessUnitState {
  activeBusinessUnit: string | null;
  setActiveBusinessUnit: (businessUnit: string | null) => void;
}

export const useBusinessUnitStore = create<BusinessUnitState>()(
  persist(
    (set) => ({
      activeBusinessUnit: null,
      setActiveBusinessUnit: (businessUnit) => set({ activeBusinessUnit: businessUnit?.replace(/_/g, ' ') }),
    }),
    {
      name: 'active-business-unit-storage',
    },
  ),
);
